import { GraphQLSearchSignedClass, GraphQLSearchVariables } from "@eco/client";

export class CountryQuery implements GraphQLSearchSignedClass<GraphQLSearchVariables> {
    readonly query = `
        query get_country {
            country { deId deKe  deLi }
        }
    `;
    readonly cacheKey = 'CountryQuery';
    readonly signature: string = '';

    constructor() {
        
    }
}
